import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

const useConfigBrandColor = () => {
  const { data: config } = useInstanceConfigQuery();
  return lodashGet(config, "custom_ui_labels.brandColor");
};

export { useConfigBrandColor };
